import React from 'react'
import useStyles from './styles'
import { Box, Typography } from '@material-ui/core'
import { formatMoney } from 'accounting'
import useDonationName from 'hooks/useDonationName'

const Donation = ({ donation }) => {
  const classes = useStyles()

  let donationName = ''
  if (donation.anon === 1) {
    donationName = 'Anonymous'
  } else {
    donationName = useDonationName(donation)
  }

  return (
    <Box
      display="flex"
      justifyContent="space-between"
      marginBottom={1.5}
      className={classes.donation}
    >
      <Typography className={classes.donationUserName}>
        {donationName}
      </Typography>
      <Typography className={classes.donationAmount}>
        {formatMoney(donation.donation_amt, '$', 0)}
      </Typography>
    </Box>
  )
}

export default Donation



// WEBPACK FOOTER //
// ./src/components/EngagementsBoard/DonationsList/Donation/index.jsx